const tpl = (fields) => ({ page: 'skills', ...fields })

export const SKILL_TEMPLATES_PART03 = [
  tpl({
    id: 'demo-tpl-skl-postmortem',
    title: 'Incident postmortem',
    category: 'Engineering',
    apps: ['GitHub', 'Slack'],
    description: 'A blameless postmortem drafted from the incident channel and the fixing pull requests.',
    steps: ['Rebuild the timeline from the incident channel', 'Link the PRs that caused and fixed it', 'Draft impact, root cause, and action items'],
    skill: {
      instructions: `**For the incident named:**

1. Read the incident Slack channel and build a timeline in UTC: detection, escalation, mitigation, resolution.
2. Find the pull requests that introduced and fixed the problem.
3. Write **Summary**, **Impact**, **Root cause**, **What went well**, **What went badly**, **Action items** (with owners).
4. Keep it blameless: describe systems and decisions, not people.`,
      examples: ['Write the postmortem for last night’s ingestion outage', 'Draft a postmortem from #inc-2026-09-30'],
    },
  }),
  tpl({
    id: 'demo-tpl-skl-pr-description',
    title: 'PR description writer',
    category: 'Engineering',
    apps: ['GitHub'],
    description: 'Writes a reviewer-friendly description from the diff: what changed, why, and how it was tested.',
    steps: ['Read the diff and linked issue', 'Explain the change and the reason for it', 'List how to test and what to watch'],
    skill: {
      instructions: `**For the pull request given:**

1. Read the diff, the commits, and any linked issue.
2. Write **What** (two sentences), **Why** (the problem it solves), and **How to test** (numbered steps).
3. Call out risky areas, migrations, or config changes under **Watch for**.
4. Update the PR description only after showing me the draft.`,
      examples: ['Write a description for PR #482', 'Describe my open pull request on data-obs-chat'],
    },
  }),
]
